export const sliceTextContent = (content: string, limit: number = 100) => {
  return content?.length > limit ? content.substring(0, limit) + '…' : content;
};
